<div
  class="bulk-upload-panel"
  (dragover)="handlePanelDragOver($event)"
  (drop)="handlePanelDrop($event)"
>
  <ng-container [ngSwitch]="currentStep$ | async">
    <app-bulk-upload-drop *ngSwitchCase="BulkUploadStep.Drop" class="bulk-upload-panel__step">
    </app-bulk-upload-drop>

    <ng-container *ngSwitchCase="BulkUploadStep.Processing">
      <app-bulk-upload-processing class="bulk-upload-panel__step"></app-bulk-upload-processing>
    </ng-container>

    <ng-container *ngSwitchCase="BulkUploadStep.PageSelection">
      <app-bulk-upload-page-selection
        class="bulk-upload-panel__step"
        (selectionChange)="handleSelectionChange($event)"
      >
      </app-bulk-upload-page-selection>
    </ng-container>

    <app-bulk-upload-insertion-strategy
      *ngSwitchCase="BulkUploadStep.InsertStrategy"
      class="bulk-upload-panel__step"
      [selectedStrategy]="selectedInsertStrategy"
      [uploadAsSeparateImages]="uploadAsSeparateImages"
      (selectionChange)="handleStrategySelectionChange($event)"
    >
    </app-bulk-upload-insertion-strategy>

    <app-bulk-upload-arrangement
      *ngSwitchCase="BulkUploadStep.Arrangement"
      class="bulk-upload-panel__step"
      [selectedArrangement]="selectedArrangement"
      (selectionChange)="handleArrangementSelectionChange($event)"
    >
    </app-bulk-upload-arrangement>
  </ng-container>

  <div class="bulk-upload-panel__footer" *ngIf="showFooter$ | async">
    <ng-container *ngIf="selectedSingleNonPdfFile$ | async; else defaultFooter">
      <div class="bulk-upload-panel__footer-actions">
        <app-pencil-button
          class="pencil-button bottom-bar-button bottom-bar-button-bordered light medium"
          [label]="'Select another file' | translate"
          [icon]="'attach_file'"
          [iconConfig]="{ type: IconTypes.materialIcon }"
          (clickEvent)="handleSelectAnotherFile()"
        >
        </app-pencil-button>
        <app-pencil-button
          class="pencil-button bottom-bar-button primary medium"
          [label]="'Import file' | translate"
          [icon]="'arrow_forward'"
          [iconConfig]="{ type: IconTypes.matIcon }"
          (clickEvent)="handleImportSelected()"
        >
        </app-pencil-button>
      </div>
    </ng-container>
    <ng-template #defaultFooter>
      <ng-container *ngIf="currentStep$ | async as currentStep">
        <div class="bulk-upload-panel__footer-left">
          <app-pencil-button
            *ngIf="currentStep === BulkUploadStep.PageSelection; else backButton"
            class="pencil-button bottom-bar-button light medium"
            [label]="'Cancel' | translate"
            [icon]="'close'"
            [iconConfig]="{ type: IconTypes.matIcon }"
            (clickEvent)="handleBack()"
          >
          </app-pencil-button>
          <ng-template #backButton>
            <app-pencil-button
              *ngIf="currentStep !== BulkUploadStep.Drop"
              class="pencil-button bottom-bar-button light medium"
              [label]="'Back' | translate"
              [icon]="'arrow_back'"
              [iconConfig]="{ type: IconTypes.matIcon }"
              (clickEvent)="handleBack()"
            >
            </app-pencil-button>
          </ng-template>
        </div>
        <div class="bulk-upload-panel__footer-right">
          <app-pencil-button
            *ngIf="nextButtonState$ | async as nextButton"
            class="pencil-button bottom-bar-button primary medium"
            [label]="nextButton.label"
            [icon]="nextButton.icon"
            [iconConfig]="{ type: IconTypes.matIcon }"
            [disabled]="(canProceed$ | async) === false"
            (clickEvent)="handleNext()"
          >
          </app-pencil-button>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>
